module.exports = __webpack_public_path__ + "assets/img/thumb-openinvest-get-started.780274b3.jpg";